import { Button, Form, Input, Modal, Space } from "antd";
import axios from "axios";
import React, { useContext } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const LocationModal = ({
  open,
  close,
  closeDrawer,
  product_id,
  dataSet,
  rerun,
}) => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const handleUpdateProductLocation = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("product_id", product_id);
    formdata.append("mode", dataSet !== null ? "update" : "create");

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    axios
      .post("user/merchant/update-create/product-location", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif(
            "success",
            `${
              dataSet !== null ? "Updated" : "Create"
            } product location successfully.`
          );
          setTimeout(() => {
            closeDrawer();
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{
          floor: dataSet !== null ? dataSet.floor : "",
          lane: dataSet !== null ? dataSet.lane : "",
          shelf: dataSet !== null ? dataSet.shelf : "",
          tray: dataSet !== null ? dataSet.tray : "",
        }}
        onFinish={handleUpdateProductLocation}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="floor"
            label="Floor"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="lane"
            label="Lane/Row"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="shelf"
            label="Shelf"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name="tray"
            label="Tray"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default LocationModal;
